import { Component } from '@angular/core';
import { DynamicSQLService } from '../services/dynamic-sql.service';

@Component({
  selector: 'app-dynamic-sql-column-adder',
  templateUrl: './dynamic-sql-column-adder.component.html',
  styleUrls: ['./dynamic-sql-column-adder.component.css']
})
export class DynamicSqlColumnAdderComponent {
  userInput: string = '';
   private token: string = '';

   constructor(private dynamicSqlService: DynamicSQLService) {}

  ngOnInit(): void {
    const userRaw = sessionStorage.getItem('wOSUser');
    try {
      this.token = userRaw ? (JSON.parse(userRaw)?.stsTokenManager?.accessToken ?? '') : '';
    } catch {
      this.token = '';
    }
  }

  onSubmit() {
    this.dynamicSqlService.updateTableInfo(this.userInput, this.token).subscribe();
  }
}